import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-py-1" }
const _hoisted_2 = { class: "tw-text-[12px] tw-font-normal tw-text-[#211F58] tw-px-2" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-flex-1 tw-items-center tw-min-h-[26px] tw-px-2 tw-py-1 tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1]"
}

import { onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cellDetailType4',
  props: {
    title: {},
    detail: {},
    isShowDetail: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const detailRef = ref("");
const inputRef = ref<HTMLTextAreaElement | null>(null);

const calHeight = () => {
  setTimeout(() => {
    if (!inputRef.value) {
      return;
    }
    inputRef.value.style.height = `${inputRef.value.scrollHeight}px`;
  }, 1);
};

onMounted(() => {
  detailRef.value = props.detail || "";
  calHeight();
});

watch(
  () => [props.detail, props.isShowDetail],
  () => {
    detailRef.value = props.detail || "";
    calHeight();
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.isShowDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("textarea", {
            ref_key: "inputRef",
            ref: inputRef,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detailRef).value = $event)),
            type: "text",
            readonly: "",
            disabled: "",
            class: "tw-text-[12px] tw-font-normal tw-text-[#878787] tw-w-full tw-border-0 !tw-bg-white tw-resize-none tw-overflow-hidden"
          }, null, 512), [
            [_vModelText, detailRef.value]
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})